import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    FILTERTYPE: { prop: null, param: 'FILTERTYPE', url_param: false },
    FILTERGROUP: { prop: null, param: 'FILTERGROUP', url_param: false },
    FILTER: { prop: null, param: 'FILTER', url_param: false },
    OBJFILTER: { prop: null, param: 'OBJFILTER', url_param: false },
    TIMECOLUMNFILTER: { prop: null, param: 'TIMECOLUMNFILTER', url_param: false },
}

const initialState = {
    loadIx2048ListStatus: 'idle',
    loadIx2048ListError: undefined as any,
    loadIx2048ListLastArgs: undefined as any,
    loadIx2048Status: 'idle',
    loadIx2048Error: undefined as any,
    saveIx2048Status: 'idle',
    saveIx2048Error: undefined as any,
    processIx2048Status: 'idle',
    processIx2048Error: undefined as any,

    ix2048List: [] as any[],
    currentRechnungeingangsbuch: undefined as any,
    processedRechnungeingangsbuch: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    objectFilterData: {
        objectRange:  null as any,
        objectRangeValue: null as any,
        usersData: [] as any,
        activeButtonId: null,
        userteamId: null,
        lookupName: '' as string,
        isChecked: false as boolean,
        teamShortName: null as any,
        lookupsValue: null as any
    },
    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2048List = createAsyncThunk('xsp2048Slice/loadIx2048List', async ({ gridFilters, ixCommonRuntime, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().xsp2048Slice.loadIx2048ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, ixCommonRuntime }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_ix2048/?CHECKOBJRIGHTS=-1&CHECKKRESTMRIGHTS=-1&CHECKKONTORIGHTS=-1&REBUCHFILTERID=${gridFilters.lookupValues.FILTER ? gridFilters.lookupValues.FILTER.HDR_ID : 0}&OBJEKTFILTER=${gridFilters.lookupValues.OBJFILTER?.value || 0}&TIMECOLUMNFILTER=${gridFilters.values.TIMECOLUMNFILTER || 0}&TIMEFILTERFROM=${gridFilters.values.TIMEFILTERFROM || ''}&TIMEFILTERTO=${gridFilters.values.TIMEFILTERTO || ''}&AKTOBJNR=${ixCommonRuntime.objNr || 0}`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, ixCommonRuntime }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2048ListStatus } = getState().xsp2048Slice
        return loadIx2048ListStatus !== 'pending'
    }
})

export const loadIx2048 = createAsyncThunk('xsp2048Slice/loadIx2048', async ({ selectedItem }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ReBuchScrnVars_LoadBuvorgangRebuIdToJson/?BuvorgangRebuId=${selectedItem.BUVORGANGREBU_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2048Status } = getState().xsp2048Slice
        return loadIx2048Status !== 'pending'
    }
})

export const saveIx2048 = createAsyncThunk('xsp2048Slice/saveIx2048', async ({ rechnungeingangsbuch }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/ReBuchScrnVars_SaveBuvorgangRebuFromJson/`,
        prepareData({ data: rechnungeingangsbuch }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx2048Status } = getState().xsp2048Slice
        return saveIx2048Status !== 'pending'
    }
})

export const processIx2048 = createAsyncThunk('xsp2048Slice/processIx2048', async ({ data }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/ReBuchScrnVars_ProcessBuvorgangRebuFromJson/`,
        prepareData(data),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { processIx2048Status } = getState().xsp2048Slice
        return processIx2048Status !== 'pending'
    }
})

const Ix2048Slice = createSlice({
    name: 'xsp2048Slice',
    initialState,
    reducers: {
        resetloadIx2048ListError: (state) => {
            state.loadIx2048ListError = undefined
        },
        resetloadIx2048: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.loadIx2048Error = undefined
        },
        resetloadIx2048Error: (state) => {
            state.loadIx2048Error = undefined
        },
        resetsaveIx2048: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.saveIx2048Error = undefined
        },
        resetsaveIx2048Error: (state) => {
            state.saveIx2048Error = undefined
        },
        resetprocessIx2048: (state) => {
            state.processedRechnungeingangsbuch = undefined
            state.processIx2048Error = undefined
        },
        resetprocessIx2048Error: (state) => {
            state.processIx2048Error = undefined
        },
        removeFromIx2048ListById: (state, action) => {
            state.ix2048List = state.ix2048List.filter((x: any) => x.BUVORGANGREBU_ID !== action.payload)
        },
        removeFromIx2048ListByIds: (state, action) => {
            state.ix2048List = state.ix2048List.filter((x: any) => action.payload.indexOf(x.BUVORGANGREBU_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setObjectFilterData: (state, action) => {
            state.objectFilterData = {...state.objectFilterData, ...action.payload}
        },
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2048List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2048ListStatus = 'preloaded'
            state.loadIx2048ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2048List = []
            state.loadIx2048ListStatus = 'idle'
            state.loadIx2048ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2048List.pending, (state) => {
            state.loadIx2048ListStatus = 'pending'
            state.loadIx2048ListError = undefined
        })
        builder.addCase(loadIx2048List.fulfilled, (state, action) => {
            state.loadIx2048ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2048ListLastArgs = action.payload.args

            {
                state.ix2048List = action.payload.data

            }
        })
        builder.addCase(loadIx2048List.rejected, (state, action) => {
            state.loadIx2048ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2048ListError = action.error.message
            } else {
                state.loadIx2048ListError = action.payload
            }
        })

        builder.addCase(loadIx2048.pending, (state) => {
            state.loadIx2048Status = 'pending'
            state.loadIx2048Error = undefined
        })
        builder.addCase(loadIx2048.fulfilled, (state, action) => {
            state.loadIx2048Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(loadIx2048.rejected, (state, action) => {
            state.loadIx2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2048Error = action.error.message
            } else {
                state.loadIx2048Error = action.payload
            }
        })

        builder.addCase(saveIx2048.pending, (state) => {
            state.saveIx2048Status = 'pending'
            state.saveIx2048Error = undefined
        })
        builder.addCase(saveIx2048.fulfilled, (state, action) => {
            state.saveIx2048Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(saveIx2048.rejected, (state, action) => {
            state.saveIx2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx2048Error = action.error.message
            } else {
                state.saveIx2048Error = action.payload
            }
        })

        builder.addCase(processIx2048.pending, (state) => {
            state.processIx2048Status = 'pending'
            state.processIx2048Error = undefined
        })
        builder.addCase(processIx2048.fulfilled, (state, action) => {
            state.processIx2048Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.processedRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(processIx2048.rejected, (state, action) => {
            state.processIx2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.processIx2048Error = action.error.message
            } else {
                state.processIx2048Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx2048ListError,
    resetloadIx2048,
    resetloadIx2048Error,
    resetsaveIx2048,
    resetsaveIx2048Error,
    resetprocessIx2048,
    resetprocessIx2048Error,
    removeFromIx2048ListById,
    removeFromIx2048ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setObjectFilterData,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2048Slice.actions
export default Ix2048Slice.reducer
